import i18n from "@/lang";
import { hasNonEmptyBookings } from "@/utils/vue-helpers/booking";
import { ElMessageBox } from "element-plus";
import { defineComponent } from "vue";
export default defineComponent({
  name: "ConfirmClosingSales",
  setup: function setup() {
    var t = i18n.global.t;

    var cancelClosingSales = function cancelClosingSales() {
      ElMessageBox.close();
    };

    return {
      cancelClosingSales: cancelClosingSales,
      t: t,
      hasNonEmptyBookings: hasNonEmptyBookings
    };
  }
});